function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M152.659 426.359C151.637 428.023 149.208 427.99 148.232 426.299L53.6088 262.407C53.136 261.588 53.1497 260.576 53.6446 259.77L166.704 75.6865C167.725 74.0227 170.154 74.0557 171.131 75.7467L265.754 239.639C266.227 240.458 266.213 241.47 265.718 242.276L152.659 426.359Z",
  fill: "#E8FFFC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M482.344 597.825C483.366 599.489 485.795 599.456 486.771 597.765L527.846 526.621C528.319 525.802 528.305 524.79 527.81 523.984L478.494 443.686C477.472 442.023 475.043 442.056 474.067 443.747L432.992 514.891C432.519 515.71 432.533 516.722 433.027 517.528L482.344 597.825Z",
  fill: "#E8FFFC"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_back)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M698.725 29.3247C698.778 27.3728 700.898 26.1868 702.589 27.1631L969.173 181.075C969.992 181.548 970.486 182.432 970.461 183.377L960.926 534.134C960.873 536.086 958.753 537.272 957.062 536.296L690.478 382.384C689.659 381.911 689.165 381.027 689.191 380.082L698.725 29.3247Z",
  fill: "#E8FFFC"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_back",
  x: 517.744,
  y: 0.105164,
  width: 624.163,
  height: 563.249,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12.8839,
  result: "effect1_foregroundBlur"
})));

var SvgBackParallelograms = function SvgBackParallelograms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1142,
    height: 600,
    viewBox: "0 0 1142 600",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackParallelograms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-parallelograms.54ff8d05.svg";
export { ForwardRef as ReactComponent };